import {Map} from 'mapbox-gl-js';

export default () => Map;
